import React, { useState } from 'react';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import {
  Box,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { StyledCard } from 'shared/ui/Card/StyledCard';
import { isEmptyArr } from 'shared/utils/isEmpty';
import { CountryCreateWidget } from 'widgets/settings/CountryCreateWidget';
import { useAppDispatch } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useDeleteCountryMutation } from 'features/useCountry/api/useCountryApi';

export const CountryWidget = () => {
  const [country, setCountry] = useState({});

  const response = useGetCountriesQuery(null);
  const [deleteCountry] = useDeleteCountryMutation();

  const dispatch = useAppDispatch();

  const handleDeleteCountry = async (id: number) => {
    const data = await deleteCountry({ id });
    if (data) {
      response.refetch();
    }
  };

  if (response.isFetching) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (response.isError) {
    return <Stack alignItems="center">ERROR</Stack>;
  }

  return (
    <>
      {response.isSuccess ? (
        <Box
          component={StyledCard}
          sx={{ marginBottom: '24px' }}
        >
          {!isEmptyArr(response.data) ? (
            <TableContainer>
              <Table
                sx={{ maxWidth: 500 }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: '10px 0' }}>ID</TableCell>
                    <TableCell sx={{ padding: '10px' }}>Страна</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>

                <TableBody>
                  {response.data.map((item) => (
                    <TableRow
                      key={item.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell
                        sx={{ padding: '10px 0' }}
                        component="th"
                        scope="row"
                      >
                        {item.id}
                      </TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell align="right">
                        <EditOutlinedIcon
                          onClick={() => {
                            setCountry(item);
                            dispatch(setDrawerOpen(true));
                          }}
                        />
                        <DeleteOutlinedIcon onClick={() => handleDeleteCountry(item.id)} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography sx={{ marginTop: '24px' }}>Нет стран</Typography>
          )}
        </Box>
      ) : null}

      <CountryCreateWidget
        country={country}
        setCountry={setCountry}
        refetch={response.refetch}
      />
    </>
  );
};
